// extracted by mini-css-extract-plugin
export default {"yivi-web-form":"select_candidate_yivi-web-form__qGUAH","yivi-web-content":"select_candidate_yivi-web-content__6Q9Nv","buttonCol":"select_candidate_buttonCol__DQ2x+"};